/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveNPAPTokensPriceProvider,
  CurveNPAPTokensPriceProviderInterface,
} from "../CurveNPAPTokensPriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_providersRepository",
        type: "address",
      },
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "_fetchersRepository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nullAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nativeWrappedAddr",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "CryptoPoolCantBeMetaPool",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyWETHAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNumberOfCoinsInPool",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "NotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "PoolForLPTokenNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenAlreadyInitialized",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroPrice",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "LPTokenEnabled",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "coins",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isLPToken",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lpTokenPool",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isMeta",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_lpTokens",
        type: "address[]",
      },
    ],
    name: "setupAssets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x6101006040523480156200001257600080fd5b506040516200114b3803806200114b8339810160408190526200003591620001b2565b838383836001600160a01b0381166200006157604051634812bd0f60e01b815260040160405180910390fd5b62000085836001600160a01b0316630956403e6200010f60201b620004ed1760201c565b620000a35760405163011848e160e11b815260040160405180910390fd5b6001600160a01b0392831660805290821660a052811660c052620000da90821663eec3e6a76200010f602090811b620004ed17901c565b620000f85760405163352cccdf60e01b815260040160405180910390fd5b6001600160a01b031660e052506200024692505050565b60006001600160a01b0383161580159062000192575082826040518163ffffffff1660e01b8152600401602060405180830381865afa15801562000157573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906200017d91906200021a565b60e083901b6001600160e01b03199081169116145b9392505050565b6001600160a01b0381168114620001af57600080fd5b50565b60008060008060808587031215620001c957600080fd5b8451620001d68162000199565b6020860151909450620001e98162000199565b6040860151909350620001fc8162000199565b60608601519092506200020f8162000199565b939692955090935050565b6000602082840312156200022d57600080fd5b81516001600160e01b0319811681146200019257600080fd5b60805160a05160c05160e051610eaf6200029c600039600081816101b9015281816102fd015281816103bc01528181610578015261069c015260006109a601526000610961015260006107e90152610eaf6000f3fe608060405234801561001057600080fd5b50600436106100885760003560e01c80636a40a8891161005b5780636a40a8891461013c5780638590af1514610151578063b31fb25614610164578063c42fa7f4146101a257600080fd5b8063217a4b701461008d5780632fe828c6146100b257806341976e091461010657806357e0c50f14610127575b600080fd5b6100956101b5565b6040516001600160a01b0390911681526020015b60405180910390f35b6100e76100c0366004610a89565b6001602052600090815260409020546001600160a01b03811690600160a01b900460ff1682565b604080516001600160a01b0390931683529015156020830152016100a9565b610119610114366004610a89565b61023e565b6040519081526020016100a9565b6040516357e0c50f60e01b81526020016100a9565b61014f61014a366004610a89565b6102f1565b005b61014f61015f366004610aa6565b6103b0565b610192610172366004610a89565b6001600160a01b0390811660009081526001602052604090205416151590565b60405190151581526020016100a9565b6100e76101b0366004610b1b565b6104aa565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663217a4b706040518163ffffffff1660e01b8152600401602060405180830381865afa158015610215573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102399190610b47565b905090565b6001600160a01b038082166000908152600160205260408120549091168061027957604051630280e1e560e61b815260040160405180910390fd5b6000816001600160a01b03166354f0f7d56040518163ffffffff1660e01b8152600401602060405180830381865afa1580156102b9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102dd9190610b64565b90506102e98482610573565b949350505050565b336001600160a01b03167f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663481c6a756040518163ffffffff1660e01b8152600401602060405180830381865afa158015610359573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061037d9190610b47565b6001600160a01b0316146103a45760405163605919ad60e11b815260040160405180910390fd5b6103ad81610691565b50565b336001600160a01b03167f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663481c6a756040518163ffffffff1660e01b8152600401602060405180830381865afa158015610418573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061043c9190610b47565b6001600160a01b0316146104635760405163605919ad60e11b815260040160405180910390fd5b60005b818110156104a55761049d83838381811061048357610483610b7d565b90506020020160208101906104989190610a89565b610691565b600101610466565b505050565b600060205281600052604060002081815481106104c657600080fd5b6000918252602090912001546001600160a01b0381169250600160a01b900460ff16905082565b60006001600160a01b0383161580159061056c575082826040518163ffffffff1660e01b8152600401602060405180830381865afa158015610533573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105579190610b93565b60e083901b6001600160e01b03199081169116145b9392505050565b6000807f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166341976e09600080876001600160a01b03166001600160a01b031681526020019081526020016000206000815481106105db576105db610b7d565b60009182526020909120015460405160e083901b6001600160e01b03191681526001600160a01b039091166004820152602401602060405180830381865afa15801561062b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061064f9190610b64565b905061065b8382610bbd565b670de0b6b3a764000090049150600082900361068a57604051634dfba02360e01b815260040160405180910390fd5b5092915050565b61069a81610777565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166341976e09600080846001600160a01b03166001600160a01b031681526020019081526020016000206000815481106106ff576106ff610b7d565b60009182526020909120015460405160e083901b6001600160e01b03191681526001600160a01b039091166004820152602401602060405180830381865afa15801561074f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107739190610b64565b5050565b6001600160a01b038116600090815260208190526040902054156107ae5760405163185add2960e11b815260040160405180910390fd5b604080516080810182526000918101828152606082810193909352815260208101829052604051633afc259d60e01b81526001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001690633afc259d906108209086908690600401610c1a565b600060405180830381865afa15801561083d573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526108659190810190610d30565b8151519093509091506001600160a01b031615806108b3575060006001600160a01b031681602001516000815181106108a0576108a0610b7d565b60200260200101516001600160a01b0316145b156108d15760405163136306a360e31b815260040160405180910390fd5b602081015151600211156108f857604051630c9e948d60e21b815260040160405180910390fd5b8051602001511561091c576040516372775d0f60e01b815260040160405180910390fd5b60006040518060400160405280836020015160008151811061094057610940610b7d565b60200260200101516001600160a01b031681526020016000151581525090507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031681600001516001600160a01b0316036109c9576001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001681525b6001600160a01b03848116600081815260208181526040808320805460018082018355918552838520885191018054898601519289166001600160a81b031991821617600160a01b9315158402179091558951878752928552838620835181549490960151958916939091169290921793151502929092179182905551929316917f1c6312856df22d497cfb4f299f8cfcba47e075c8578286a8ad07568d8457a3fd9190a350505050565b6001600160a01b03811681146103ad57600080fd5b600060208284031215610a9b57600080fd5b813561056c81610a74565b60008060208385031215610ab957600080fd5b823567ffffffffffffffff80821115610ad157600080fd5b818501915085601f830112610ae557600080fd5b813581811115610af457600080fd5b8660208260051b8501011115610b0957600080fd5b60209290920196919550909350505050565b60008060408385031215610b2e57600080fd5b8235610b3981610a74565b946020939093013593505050565b600060208284031215610b5957600080fd5b815161056c81610a74565b600060208284031215610b7657600080fd5b5051919050565b634e487b7160e01b600052603260045260246000fd5b600060208284031215610ba557600080fd5b81516001600160e01b03198116811461056c57600080fd5b6000816000190483118215151615610be557634e487b7160e01b600052601160045260246000fd5b500290565b60005b83811015610c05578181015183820152602001610bed565b83811115610c14576000848401525b50505050565b60018060a01b03831681526040602082015260008251806040840152610c47816060850160208701610bea565b601f01601f1916919091016060019392505050565b634e487b7160e01b600052604160045260246000fd5b6040805190810167ffffffffffffffff81118282101715610c9557610c95610c5c565b60405290565b604051601f8201601f1916810167ffffffffffffffff81118282101715610cc457610cc4610c5c565b604052919050565b600082601f830112610cdd57600080fd5b815167ffffffffffffffff811115610cf757610cf7610c5c565b610d0a601f8201601f1916602001610c9b565b818152846020838601011115610d1f57600080fd5b6102e9826020830160208701610bea565b60008060408385031215610d4357600080fd5b825167ffffffffffffffff80821115610d5b57600080fd5b908401908186036060811215610d7057600080fd5b610d78610c72565b6040821215610d8657600080fd5b610d8e610c72565b91508351610d9b81610a74565b82526020848101518015158114610db157600080fd5b8382015291815260408401519183831115610dcb57600080fd5b828501945088601f860112610ddf57600080fd5b8451925083831115610df357610df3610c5c565b8260051b610e02828201610c9b565b938452858101820193828101908b861115610e1c57600080fd5b968301965b85881015610e465787519250610e3683610a74565b8282529683019690830190610e21565b84840152505087015190955092505080821115610e6257600080fd5b50610e6f85828601610ccc565b915050925092905056fea2646970667358221220695632d1c6bcc0cdd29005cd35ebf520830aef57ae4134ba089d92a87b3fcc0264736f6c634300080d0033";

type CurveNPAPTokensPriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveNPAPTokensPriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveNPAPTokensPriceProvider__factory extends ContractFactory {
  constructor(...args: CurveNPAPTokensPriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveNPAPTokensPriceProvider";
  }

  deploy(
    _providersRepository: string,
    _fetchersRepository: string,
    _nullAddr: string,
    _nativeWrappedAddr: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveNPAPTokensPriceProvider> {
    return super.deploy(
      _providersRepository,
      _fetchersRepository,
      _nullAddr,
      _nativeWrappedAddr,
      overrides || {}
    ) as Promise<CurveNPAPTokensPriceProvider>;
  }
  getDeployTransaction(
    _providersRepository: string,
    _fetchersRepository: string,
    _nullAddr: string,
    _nativeWrappedAddr: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _providersRepository,
      _fetchersRepository,
      _nullAddr,
      _nativeWrappedAddr,
      overrides || {}
    );
  }
  attach(address: string): CurveNPAPTokensPriceProvider {
    return super.attach(address) as CurveNPAPTokensPriceProvider;
  }
  connect(signer: Signer): CurveNPAPTokensPriceProvider__factory {
    return super.connect(signer) as CurveNPAPTokensPriceProvider__factory;
  }
  static readonly contractName: "CurveNPAPTokensPriceProvider";
  public readonly contractName: "CurveNPAPTokensPriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveNPAPTokensPriceProviderInterface {
    return new utils.Interface(_abi) as CurveNPAPTokensPriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveNPAPTokensPriceProvider {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveNPAPTokensPriceProvider;
  }
}
